import type { AxiosResponse } from "axios";

import type {
  CancelableAxiosPromise,
  S3PutSuccess,
} from "cortex/ui/src/service/base";
import { baseService } from "cortex/ui/src/service/base";

export const contentGroupService = {
  load(): CancelableAxiosPromise {
    return baseService.get("/api/content-groups");
  },

  new(name: string, contents: unknown[]): CancelableAxiosPromise {
    return baseService.post("/api/content-group", { contents, name });
  },

  edit(
    id: string | number,
    name: string,
    contents: unknown[],
  ): Promise<AxiosResponse | S3PutSuccess> {
    return baseService.put(`/api/content-group/${id}`, { contents, name });
  },
};

export default contentGroupService;
